// extracted by mini-css-extract-plugin
export var iframe = "iframe-module--iframe--a37b8";
export var iframe__border = "iframe-module--iframe__border--0effb";
export var spin = "iframe-module--spin--c25b3";